var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOtherVideosIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 11.25V17.25L15 14.25L9.75 11.25Z",
    fill: "#1E8B7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 21H4.5C4.1023 20.9996 3.721 20.8414 3.43978 20.5602C3.15856 20.279 3.0004 19.8977 3 19.5V9C3.0004 8.6023 3.15856 8.221 3.43978 7.93978C3.721 7.65856 4.1023 7.5004 4.5 7.5H19.5C19.8977 7.5004 20.279 7.65856 20.5602 7.93978C20.8414 8.221 20.9996 8.6023 21 9V19.5C20.9996 19.8977 20.8414 20.279 20.5602 20.5602C20.279 20.8414 19.8977 20.9996 19.5 21ZM4.5 9V19.5H19.5V9H4.5ZM4.5 4.5H19.5V6H4.5V4.5ZM6 1.5H18V3H6V1.5Z",
    fill: "#1E8B7C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherVideosIcon);
export default __webpack_public_path__ + "static/media/other-videos-icon.7518dbed.svg";
export { ForwardRef as ReactComponent };